import requests from './request';

// 生成订单信息
export const userDetail = (params)=>requests({url:'/customer/user/userDetail', method:'post', data:params});
// 编辑顾客个人信息
export const editCustomerInfo = (params)=>requests({url:'/customer/user/editCustomerInfo', method:'post', data:params});
// 删除诊疗记录
export const deleteRecord = (params)=>requests({url:'/customer/user/deleteRecord', method:'post', data:params});